import {TenenciaItem} from "../../users/interfaces/proyecto.interface";

export interface PersonasProyectoInterface {
    activeStep:number,
    titulo:string,
    subtitulo?:string,
    tituloFile?:string,
    tooltipFile?:string,
    notaAlPieFile?:string,
    dropDown?:Dropdown;
    tenencias?: TenenciaItem[];
}
export interface Option {
    key: string;
    value: string;
}

export interface Dropdown {
    key: string;
    label: string;
    required: boolean;
    disabled: boolean;
    completed: boolean;
    order: number;
    options: Option[];
    type: string;
}

export class FieldPersonas<T> {
    step: number;
    titulo:string;//titulo principal del compoente
    subtitulo:string;
    placeholder:string; // etiqueta para mostrar mensaje  informativo dentro del componente
    typeStep: string;
    components:Components[]; //para dibujar los tipo de componentes
    pieValidTable:string;//mensaje de validacion para la tabla
    disableComponent:boolean; // validacion para desactivar o activar duplicacion de componetes externos en los pasos

    constructor(
        options: {
            step?: number;
            titulo?: string;
            subtitulo?: string;
            placeholder?: string;
            typeStep?: string;
            components?: Components[];
            pieValidTable?:string;
            disableComponent?:boolean;
        } = {},
    ) {
        this.step = options.step || 0;
        this.titulo = options.titulo || '';
        this.subtitulo = options.subtitulo || '';
        this.placeholder = options.placeholder || '';
        this.typeStep = options.typeStep || '';
        this.components = options.components || [];
        this.pieValidTable=options.pieValidTable || '';
        this.disableComponent=options.disableComponent || false;
    }
}
export interface Options {
    key: string;
    value: string,
    estado?: boolean,
    idRequisito?: number,
    tituloFile?:string,
    tituloInfo?:string
}
export interface ErrorMessages {
    id:number;
    value:string;
    estado:boolean;
    order:number;
    type:string;
}

export interface DropdownItem {
    key: string;
    descripcion: string;
    estado: boolean;
    idRequisito:number;

}

export interface Components{
    key: string;
    label: string;
    placeholder:string;
    required: boolean;
    disabled: boolean;
    completed: boolean;
    order: number;
    controlType: string;
    type: string;
    options?: Options[];
    values?: { key: string; value: string }[];
}

